<template>
  <div v-if="content.show">
    <p class="text" :class="chooseColor(type)">第<span class="text-label">{{content.order}}</span>:{{content.title}}</p>
    <button class="btn-green" :class="[isActive[index]?classA[index]:classB[index],chooseColor(type)]" v-for="(item,index) in content.answer" @click="selectCurrent(index,item,content.num)">
    <i :class="classA[index]?'iconfont icon-check':''" ></i>
    <i :class="classB[index]?'iconfont icon-icon_close':''" ></i>
    {{item}}
    </button>
  </div>
</template>
<!--多答案-->
<script>
export default {
  props:{
    content: Object,
    type:Number
  },
  data(){
    return{
       isActive:[false,false,false,false],
       classA:['','','',''],
       classB:['','','',''],
       status:false
    }
  },
  methods:{
    chooseColor(type){
      // 毕业去向探索样式
      if(type==1){
        return 'deep-blue'
      }
    },
    selectCurrent:function(index,item,num){
      const _this = this;
      let answer = item[0];
      if(answer=="正"){
        answer=1;
      }else if(answer=="错"){
        answer=0;
      }
      if(!_this.status){
        if(answer==_this.content.rightAnswer){
           _this.$set(_this.isActive, index, true)
           _this.$set(_this.classA, index, 'btn-right')
        }else{
          _this.$set(_this.isActive, index, false)
          _this.content.answer.map((item,zindex)=>{
           if(item.indexOf(_this.content.rightAnswer)==0){
             _this.$set(_this.isActive, zindex, true)
             _this.$set(_this.classA, zindex, 'btn-right')
           }
          })
          _this.$set(_this.classB, index, 'btn-wrong')
        }
        _this.status=true
        _this.$emit("listenToChildEvent",answer,num)
      }
    }
  }
}
</script>
<style scoped>
  p{
    margin:1rem auto 0.64rem auto;
    padding:0.2rem;
    background-color:#82C9A1;
    font-weight:bold;
    color:#ffffff;
    border-radius:10px;
    width: 4.8rem;
    height: 4.5rem;
    font-size: 0.32rem;
  }
  .btn-green{
    display: block;
    padding:0.2rem 0.2rem;
    color:#ffffff;
    text-align: left;
    border:none;
    margin:center;
    width: 4.2rem;
    margin: 0.32rem auto;
    font-size:0.28rem;
    background-color:#82C9A1;
  }
  .icon-check{
    font-weight:bold;
    color:#24C130;
    font-size:0.36rem;
  }
  .icon-icon_close{
    color: #DC6E5A;
    font-size:0.28rem;
  }
  .btn-right{
    border:3px #24C130 solid;
  }
  .btn-wrong{
    border:3px #DC6E5A solid;
  }
  .deep-blue{
    background-color:#2A74B5;
  }
</style>
